import { makeRequest } from "src/services/restcall";
import { ApiResponse } from "src/services/types";
import HttpMethod from '../../services/httpMethods'

export async function getAllTagTableAPI(): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/tag',{})
}
export async function getTagByIdAPI(value:string): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/tag/id/' + value, {})
}
export async function postRegisterTagAPI(value: Object): Promise<ApiResponse>{
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/tag', value)
}
export async function putUpdateTagAPI(value: Object) : Promise<ApiResponse>{
    return await makeRequest(HttpMethod.PUT, '/api/emissionsource/tag',value)
}
